import { talearooLegal } from './legal-data.js';
const { reseller, support, abuse } = talearooLegal;
/**
 * TaleAroo is the North American market, talearoo.com.
 *
 * Prices were set on 27 September 2026 against measured list-price cost and competitors'
 * prices (docs/north-america-market-research.md §3), not converted from the ruble prices.
 * `book` sits with the best one-off digital books ($14.99); the animated tiers are priced for
 * what few competitors sell. The merchant of record is Polar, see `legal-data.ts`.
 */
export const brand = {
    id: 'talearoo',
    name: 'TaleAroo',
    domain: 'talearoo.com',
    // "Puddle Hop", the published showcase book (#48). `from=landing` makes its back link
    // return to the landing instead of offering to register.
    landingExamplePath: '/p/5RUMoayD7hakNVqjBMaFMA?from=landing',
    // The same showcase from inside the app, not the bundled sketch book.
    onboardingExamplePath: '/p/5RUMoayD7hakNVqjBMaFMA?from=landing',
    // A single language: the Russian locale is not needed here and is not bundled.
    locales: ['en'],
    defaultLocale: 'en',
    emailLocale: 'en',
    // The storefront's orange (`--ta-orange-deep`, the darker of the two: white text on it reads).
    emailAccent: '#d9551b',
    // English, and the two languages most spoken at home after it in the US and Canada.
    bookLanguages: ['en', 'fr', 'es'],
    /*
     * North American paper, in inches. Letter first: it is the paper a family has at home and
     * a print shop has on the shelf. 8.5 × 8.5 in is the most common picture-book trim and
     * 8 × 10 in the common portrait one. All three are KDP paperback trims (KDP's hardcover
     * trims are other sizes); IngramSpark names 8.5 × 8.5 as its picture-book trim. Both smaller
     * sizes print on Letter with a trim. Sources in the PR for #49.
     */
    printSizes: [
        { format: 'LETTER', names: { en: 'US Letter, 8.5 × 11 in' } },
        { format: 'SQUARE_8_5IN', names: { en: 'Square, 8.5 × 8.5 in' } },
        { format: 'PORTRAIT_8X10IN', names: { en: 'Portrait, 8 × 10 in' } },
    ],
    // Picked by ear on 7 October 2026 over MiniMax's Calm_Woman and Patient_Man (#120).
    narration: {
        model: 'google/gemini-3.8-flash/text-to-speech',
        female: 'Callirrhoe',
        male: 'Iapetus',
    },
    currency: 'USD',
    priceLocale: 'en-US',
    // Polar adds US and Canadian sales tax at checkout from the buyer's address, so
    // the price shown is before tax.
    priceNotes: {
        en: 'Prices are in US dollars; buyers in Canada pay in Canadian dollars. Sales tax, where it applies, is added at checkout.',
    },
    ogImageAlt: {
        en: 'The TaleAroo logo, its two o’s drawn as eyes, above the words “A picture book starring your kid”',
    },
    printHighQuality: {
        en: 'High-quality print layout, at a higher resolution',
    },
    // Dollar prices are shown with cents: $14.00.
    priceFractionDigits: 2,
    planPrices: {
        book: 1_400,
        live_book: 2_900,
        gift_book: 5_900,
    },
    imagePackPrice: 600,
    // Canadian buyers are charged CAD; everyone else USD. Hand-set on 28 September 2026 at
    // ~1.37 CAD per USD, rounded down to a whole dollar so CAD is never dearer than USD, and
    // the gift book under 80. Revised by hand, never converted: a big move of the rate is a
    // reason to revisit them.
    alternativePrices: [
        {
            currency: 'CAD',
            planPrices: { book: 1_900, live_book: 3_900, gift_book: 7_900 },
            imagePackPrice: 800,
        },
    ],
    support: { email: support.email, replyWithinHours: 24 },
    // Same source as the legal documents use, so the address on the public book page cannot
    // drift from the one printed in the privacy policy.
    abuse: { email: abuse.email },
    mor: { kind: 'reseller', provider: 'Polar', sellerName: reseller.name },
    paymentProviderName: 'Polar',
};
//# sourceMappingURL=brand.js.map